<template>
  <div>
    <img class="header-back-btn" src="@/assets/img/header-back-btn.png" alt="" @click="backLogon" />
    <div class="login">
      <img class="logo" src="@/assets/img/logo.png" alt="" />
      <div class="title">
        {{ title }}
      </div>
      <form class="login-content" @submit.prevent="onSubmit">
        <div class="input-block">
          <div>Nomor Hp</div>
          <div class="input_box">
            <input v-model.trim="phone" type="tel" autofocus placeholder="Silakan masukkan nomor HP denganawalan 08"
              maxlength="13" />
          </div>
        </div>
        <div v-if="showPasswordInput" class="input-block">
          <div>Password</div>
          <div class="input_box">
            <input v-model.trim="password" maxlength="13" type="text" class="password" :placeholder="tipText" />
          </div>
        </div>
        <div v-if="showPasswordInput" class="input-block">
          <div>Konfirmasi password</div>
          <div class="input_box">
            <input v-model.trim="password1" maxlength="13" type="teltext" class="password" :placeholder="tipText" />
          </div>
        </div>
        <div class="input-block">
          <div>Kode verifikasi robot</div>
          <div class="img-code">
            <input v-model="imgVerifyCode" placeholder="Silakan masukkan kodeverifikasi robot" type="tel"
              maxlength="4" />
            <img v-show="phone.length > 8" class="code" ref="verifyImg" @click="refreshVerifyCode" />
            <div v-show="phone.length <= 8" class="code"></div>
            <img class="refresh" src="@/assets/img/refresh-icon.png" @click="refreshVerifyCode" />
          </div>
        </div>
        <div class="SMS-code">
          <div class="title">Kode verifikasi SMS</div>
          <input v-model="verifyCode" type="tel" maxlength="4" />
          <div class="box">
            <span>{{ verifyCode[0] }}</span>
            <span>{{ verifyCode[1] }}</span>
            <span>{{ verifyCode[2] }}</span>
            <span>{{ verifyCode[3] }}</span>
          </div>
          <div class="verify-code-btn" @click="getVerifyCode">
            <span v-if="isGetCode" style="color: #5f77f3">Dapatkan kode verifikasi</span>
            <span v-else>Dapatkan kembali({{ countDown }}s)</span>
          </div>
        </div>
        <!-- <button
          type="submit"
          :class="['confirm-btn', showPasswordInput ? 'near' : 'far']"
        >
          {{ buttonText }}
        </button> -->
        <div class="login-btn" @click="onSubmit">
          <button type="submit">Yakin</button>
          <img src="@/assets/img/login_btn_yinying.png" alt="" />
        </div>
      </form>
    </div>
    <van-dialog v-model="showCodeChannelDialog" :showConfirmButton="false" :close-on-click-overlay="!isSendingCode"
      class="code-channel-dialog">
      <div class="code-channel-box">
        <i class="channel-close-btn" role="button" tabindex="0" aria-label="Tutup" @click="closeCodeChannelDialog"
          @keyup.enter="closeCodeChannelDialog"></i>
        <div :class="['channel-badge', codeChannel]">{{ isWaCodeChannel ? 'WA' : 'SMS' }}</div>
        <h3 class="channel-title">{{ channelText.title }}</h3>
        <p class="channel-desc">{{ channelText.description }}</p>
        <div v-if="isWaCodeChannel" class="channel-tips">
          <p v-for="(tip, index) in channelText.tips" :key="index">{{ tip }}</p>
        </div>
        <div class="channel-actions">
          <button type="button" class="channel-switch-btn" :disabled="isSendingCode" @click="switchCodeChannel">
            {{ switchCodeChannelText }}
          </button>
          <button type="button" class="channel-send-btn" :disabled="isSendingCode" @click="sendVerifyCode">
            Kirim
          </button>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="showContactMsg" :showConfirmButton="false">
      <div class="showContactMsg">
        <h3>Tips Penting</h3>
        <p>Harap aktifkan izin buku alamat sesuai persyaratan berikut untuk terus menggunakannya:</p>
        <p>Harap aktifkan izin "Akses Penuh" untuk (nama aplikasi) di "Pengaturan" - "Privasi" - "Kontak" di iPhone
          Anda.</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast, Dialog, Icon } from 'vant'
import request from '@/utils/request'
import { validatePhoneNumber, validatePassword, validateVerifyCode } from '@/utils/validator'
import dialogVisible from '@/mixins/dialogVisible'
import { baseURL } from '@/config'
import { getContactsFromStorage } from '@/utils/submitContacts'
Vue.use(Icon)

Vue.use(Toast)
const maxTime = 150
let timer
const clearTimer = () => {
  timer && clearTimeout(timer) && (timer = null)
}
const titleMap = {
  forgetPassword: 'Lupa Password',
  messageLogin: 'Login dengan SMS',
  register: 'Daftar'
}
const buttonText = {
  forgetPassword: 'Yakin',
  messageLogin: 'Login',
  register: 'Daftar'
}
const apiMap = {
  forgetPassword: 'usdrerForgetPassword',
  messageLogin: 'usdrerLogin',
  register: 'usdrerRegistration'
}

const messageTypeMap = {
  forgetPassword: 3,
  messageLogin: 2,
  register: 1
}

const codeTypeSms = 1
const codeTypeWhatsapp = 2
const codeChannelSms = 'sms'
const codeChannelWhatsapp = 'whatsapp'
const whatsappSentStorageKey = 'clh5WhatsappCodeSentMap'
const channelTextMap = {
  whatsapp: {
    title: 'Dapatkan kode verifikasi WhatsApp',
    description: 'Kode verifikasi telah dikirim ke WhatsApp Anda, harap periksa pesan WhatsApp Anda. Jika belum menerima, mohon perhatikan!',
    tips: [
      'Ponsel harus terpasang aplikasi WhatsApp',
      'WhatsApp harus dalam keadaan aktif / terbuka agar dapat menerima kode verifikasi',
      'Nomor ponsel yang didaftarkan harus memiliki akun WhatsApp'
    ]
  },
  sms: {
    title: 'Dapatkan kode verifikasi SMS',
    description: 'Kode verifikasi telah dikirim ke ponsel Anda, harap periksa SMS. Jika belum menerima, silakan cek folder spam / sampah SMS',
    tips: []
  }
}

export default {
  name: 'LoginForm',
  props: {
    type: {
      type: String,
      required: true
    }
  },
  mixins: [dialogVisible],
  data () {
    return {
      phone: '',
      password: '',
      password1: '',
      verifyCode: '',
      imgVerifyCode: '',
      isGetCode: true,
      countDown: maxTime,
      verifyImg: '',
      verifyImgCodes: [
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        },
        {
          value: ''
        }
      ],
      errorInfo: '',
      showContactMsg: false,
      showCodeChannelDialog: false,
      codeChannel: codeChannelSms,
      codeType: codeTypeSms,
      isSendingCode: false
    }
  },
  components: {
    [Dialog.Component.name]: Dialog.Component
  },
  created () {
    if (this.type === 'register') {
      const contant = getContactsFromStorage()
      if (contant.length === 0) {
        this.showContactMsg = true
      }
    }
  },
  computed: {

    title () {
      return titleMap[this.type]
    },
    buttonText () {
      return buttonText[this.type]
    },
    showPasswordInput () {
      return this.type === 'forgetPassword' || this.type === 'register'
    },
    tipText () {
      if (this.type === 'register') {
        return 'Kombinasi angka dan huruf tanpa karakter spesial8-13 digit'
      } else {
        return 'Kombinasi angka dan huruf tanpa karakter spesial8-13 digit'
      }
    },
    isWaCodeChannel () {
      return this.codeChannel === codeChannelWhatsapp
    },
    channelText () {
      return channelTextMap[this.codeChannel]
    },
    switchCodeChannelText () {
      return this.isWaCodeChannel ? 'SMS' : 'WhatsApp'
    }
  },
  watch: {
    phone (val) {
      if (val && val.length > 7) {
        this.getImgVerifyCode()
      }
    }
  },
  methods: {

    validatePhoneNumber () {
      if (!this.phone) {
        Toast('Masukkan nomor handphone dengan awalan 08')
        return false
      }
      if (!validatePhoneNumber(this.phone)) {
        Toast('Nomor handphone salah')
        return false
      }
      return true
    },
    validate () {
      if (!this.validatePhoneNumber()) return false
      if (this.showPasswordInput) {
        if (!this.password) {
          Toast(this.tipText)
          return false
        }
        if (this.password !== this.password1) {
          Toast('Kata sandi tidak konsisten')
          return false
        }
        if (!validatePassword(this.password)) {
          Toast('Masukkan Kombinasi angka dan huruf tanpa karakter spesial8-13 digit')
          return false
        }
      }
      if (!this.verifyCode) {
        Toast('Masukkan 4 digit angka kode verifikasi')
        return false
      }
      if (!validateVerifyCode(this.verifyCode)) {
        Toast('Kode verifikasi salah')
        return false
      }
      return true
    },
    startCountDown () {
      if (this.countDown <= 0) {
        this.reset()
      } else {
        timer = setTimeout(() => {
          this.countDown--
          this.startCountDown()
        }, 1000)
      }
    },
    getVerifyCode () {
      if (!this.validatePhoneNumber()) return
      if (this.type === 'register') {
        if (!validatePassword(this.password)) {
          Toast('Masukkan 8 digit angka password')
          return false
        }
      }
      if (this.showPasswordInput) {
        if (this.password !== this.password1) {
          Toast('Kata sandi tidak konsisten')
          return false
        }
      }

      if (this.imgVerifyCode.length !== 4) {
        Toast('Masukkan kode verifikasi yang tertera digambar')
        return
      }
      const postData = {
        usdrerPhone: this.phone,
        grdraphicCode: this.imgVerifyCode,
        tydrpe: messageTypeMap[this.type],
        smdrsType: 1
      }
      request.post('usdrercheckGraphic', postData).then(res => {
        this.codeChannel = this.hasSentWhatsappToday() ? codeChannelSms : codeChannelWhatsapp
        this.showCodeChannelDialog = true
      }).catch(() => {
        this.imgVerifyCode = ''
        this.getImgVerifyCode()
      })
    },
    getTodayKey () {
      const now = new Date()
      const month = `${now.getMonth() + 1}`.padStart(2, '0')
      const date = `${now.getDate()}`.padStart(2, '0')
      return `${now.getFullYear()}-${month}-${date}`
    },
    getWhatsappSentMap () {
      try {
        return JSON.parse(localStorage.getItem(whatsappSentStorageKey)) || {}
      } catch (err) {
        return {}
      }
    },
    hasSentWhatsappToday () {
      const sentMap = this.getWhatsappSentMap()
      return sentMap[this.phone] === this.getTodayKey()
    },
    markWhatsappSentToday (phone = this.phone) {
      try {
        const sentMap = this.getWhatsappSentMap()
        sentMap[phone] = this.getTodayKey()
        localStorage.setItem(whatsappSentStorageKey, JSON.stringify(sentMap))
      } catch (err) {
        return false
      }
      return true
    },
    switchCodeChannel () {
      if (this.isSendingCode) return
      this.codeChannel = this.isWaCodeChannel ? codeChannelSms : codeChannelWhatsapp
    },
    closeCodeChannelDialog () {
      if (this.isSendingCode) return
      this.showCodeChannelDialog = false
    },
    getSendCodeApi (codeType) {
      return codeType === codeTypeWhatsapp ? 'sendWaSms' : 'usdrersendMessages'
    },
    sendVerifyCode () {
      if (!this.validatePhoneNumber()) return
      if (this.isSendingCode) return
      const codeType = this.isWaCodeChannel ? codeTypeWhatsapp : codeTypeSms
      const codeChannel = this.codeChannel
      const phone = this.phone
      const postData = {
        usdrerPhone: phone,
        grdraphicCode: this.imgVerifyCode,
        tydrpe: messageTypeMap[this.type],
        smdrsType: 1
      }
      this.imgVerifyCode && (postData.imdrgCode = this.imgVerifyCode)
      this.isSendingCode = true
      request.post(this.getSendCodeApi(codeType), postData)
        .then(() => {
          this.codeType = codeType
          if (codeType === codeTypeWhatsapp) {
            this.markWhatsappSentToday(phone)
          }
          Toast(channelTextMap[codeChannel].description)
          this.showCodeChannelDialog = false
          this.countDown = maxTime
          this.isGetCode = false
          this.startCountDown()
        })
        .catch(err => {
          this.showCodeChannelDialog = false
          if (err.code === 504) {
            this.imgVerifyCode = ''
            this.getImgVerifyCode()
          }
          this.reset()
        })
        .finally(() => {
          this.isSendingCode = false
        })
    },
    getImgVerifyCode () {
      this.$refs.verifyImg.src = `${baseURL}usdrergetGraphic?usdrerPhone=${this.phone}&t=${+Date.now()}`
    },
    reset () {
      clearTimer()
      this.isGetCode = true
      this.countDown = maxTime
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const postData = {
        usdrerPhone: this.phone,
        smdrs_Verificationcode: this.verifyCode,
        smdrsType: 1,
        codeType: this.codeType
      }
      if (this.type === 'forgetPassword') {
        postData.usdrerPassword = this.password
      } else if (this.type === 'messageLogin') {
        postData.lodrginType = 2
      } else if (this.type === 'register') {
        const ixabisoelinye = sessionStorage.getItem('ixabisoelinye')
        if (ixabisoelinye) {
          postData.ixabisoelinye = ixabisoelinye
        }
        const apitype = localStorage.getItem('apitype')
        if (apitype) {
          postData.apitype = apitype
        }
        postData.usdrerPassword = this.password
        postData.prdromotionChannel = 'AppStore'
      }
      request.post(apiMap[this.type], postData)
        .then(res => {
          if (this.type === 'forgetPassword') {
            const { query } = this.$route
            this.$router.push({
              path: '/login',
              query
            })
          } else if (this.type === 'register' || this.type === 'messageLogin') {
            if (this.type === 'register' && window.webkit && window.webkit.messageHandlers) {
              // H5 中调用 Facebook 埋点
              if (window.webkit.messageHandlers.rptmc) {
                window.webkit.messageHandlers.rptmc.postMessage('')
              }
              if (window.webkit.messageHandlers.sadkjfskl) {
                window.webkit.messageHandlers.sadkjfskl.postMessage('')
              }
            }
            this.$store.commit('recordInfo', {
              type: 'userInfo',
              value: res
            })
            localStorage.setItem('userInfo', JSON.stringify(res))
            this.addressBook()
            this.$router.push('/home')
          }
        })
        .finally(() => {
          this.flag = false
          this.verifyCode = ''
        })
    },

    refreshVerifyCode () {
      this.getImgVerifyCode()
    },
    onInput (index) {
      if (this.verifyImgCodes[index].value && index < 3) {
        console.log('onInput', index)
        this.$refs[`input${index + 1}`][0].focus()
      }
    },
    onDelete (index) {
      if (index > 0) {
        this.$refs[`input${index - 1}`][0].focus()
        console.log('onDelete', index)
      }
    },
    backLogon () {
      this.$router.back()
    }
  },
  deactivated () {
    this.reset()
  }
}
</script>

<style scoped lang="less">
.header-back-btn {
  width: 22px;
  padding-left: 30px;
  padding-top: 40px;
  margin-bottom: 20px;
}

.login {
  padding: 0 37px;
  padding-bottom: 100px;

  .logo {
    width: 120px;
    margin-bottom: 40px;
  }

  .title {
    font-weight: 600;
    font-size: 38px;
    margin-bottom: 40px;
  }
}

.input-block {
  div {
    color: #979696;
    font-size: 24px;
    margin-bottom: 14px;
  }

  &:nth-child(n + 2) {
    margin-top: 50px;
  }

  .img-code {
    display: flex;
    align-items: center;
    height: 88px;
    font-size: 26px;
    background: #ffffff;
    box-shadow: 0px 14px 37px 10px rgba(154, 182, 252, 0.28);
    border-radius: 20px;
    padding: 0 20px;
    padding-left: 0;

    .code {
      width: 180px;
      height: 80px;
      background: #f7f7f7;
      margin-left: auto;
      margin-bottom: 0;
    }

    .refresh {
      width: 30px;
      margin-left: 10px;
    }

    input {
      background: none;
      box-shadow: none;
      width: 420px;

      &::placeholder {
        font-size: 22px;
      }
    }
  }

  .input_box {
    box-shadow: 0px 14px 37px 10px rgba(154, 182, 252, 0.28);
    border-radius: 20px;
  }

  input {
    display: block;
    width: 100%;
    height: 88px;
    line-height: 88px;
    padding-left: 20px;
    border: none;
    box-sizing: border-box;
    font-size: 30px;
    background: #ffffff;
    border-radius: 20px;
    color: #333;

    &::placeholder {
      font-size: 23px;
    }

    &:-webkit-autofill {
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

.SMS-code {
  position: relative;
  margin-top: 50px;

  .title {
    color: #979696;
    font-size: 24px;
    margin-bottom: 14px;
    font-weight: 400;
  }

  input {
    position: absolute;
    border: 1px solid #ccc;
    left: 0;
    right: 0;
    opacity: 0;
    height: 100px;
  }

  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    span {
      display: inline-block;
      border-radius: 20px;
      border: 2px solid #bbb;
      height: 100px;
      width: 100px;
      text-align: center;
      line-height: 100px;
    }
  }
}

.password {
  -webkit-text-security: disc;
}

.verify-code-block {
  position: relative;

  input {
    flex: 1;
    border-radius: 10px 0 0 10px;
  }

  input::placeholder {
    font-weight: 500;
    font-size: 24px;
    color: #ffffff;
  }
}

.verify-code-btn {
  font-weight: 600;
  font-size: 27px;
  color: #989797;
}

.count-down {
  padding-top: 0;
  line-height: 88px;
}

.confirm-btn {
  .submit-btn;
  width: 100%;
  margin-top: 70px;
}

.code-channel-dialog {
  width: 650px;
  border-radius: 36px;
  overflow: visible;
  background: transparent;
}

.code-channel-box {
  position: relative;
  padding: 152px 42px 38px;
  border-radius: 36px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: left;
  background-color: #fff;
  box-shadow: 0 30px 80px rgba(31, 54, 138, 0.28);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 104px;
    background: linear-gradient(135deg, #5f77f3 0%, #9ab0ff 100%);
  }
}

.channel-close-btn {
  position: absolute;
  top: 22px;
  right: 26px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.24);

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 17px;
    left: 4px;
    width: 28px;
    height: 2px;
    border-radius: 2px;
    background-color: #fff;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
}

.channel-badge {
  position: absolute;
  top: 34px;
  left: 42px;
  width: 118px;
  height: 76px;
  line-height: 76px;
  border: 8px solid #fff;
  border-radius: 26px;
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  background: linear-gradient(135deg, #5f77f3 0%, #2f4fe6 100%);
  box-shadow: 0 16px 28px rgba(47, 79, 230, 0.24);

  &.whatsapp {
    background: linear-gradient(135deg, #29b66f 0%, #128c7e 100%);
  }
}

.channel-title {
  line-height: 44px;
  font-size: 30px;
  font-weight: 600;
  color: #1c2f51;
}

.channel-desc {
  line-height: 36px;
  margin-top: 18px;
  font-size: 24px;
  color: #4b5876;
}

.channel-tips {
  margin-top: 26px;
  padding: 24px 26px;
  border-left: 8px solid #5f77f3;
  border-radius: 0 18px 18px 0;
  background-color: #f4f7ff;
  text-align: left;

  p {
    position: relative;
    line-height: 32px;
    padding-left: 22px;
    font-size: 22px;
    color: #4b5876;

    &::before {
      content: '';
      position: absolute;
      top: 13px;
      left: 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #5f77f3;
    }

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.channel-actions {
  display: flex;
  align-items: center;
  margin-top: 36px;
}

.channel-switch-btn,
.channel-send-btn {
  flex: 1;
  height: 80px;
  line-height: 80px;
  border: none;
  border-radius: 18px;
  font-size: 28px;
  font-weight: 600;
}

.channel-switch-btn {
  color: #5f77f3;
  border: 2px solid #dbe3ff;
  background-color: #fff;
}

.channel-send-btn {
  margin-left: 20px;
  color: #fff;
  background: linear-gradient(135deg, #5f77f3 0%, #344fe0 100%);
  box-shadow: 0 14px 24px rgba(95, 119, 243, 0.24);
}

.channel-switch-btn:disabled,
.channel-send-btn:disabled {
  opacity: 0.6;
}

.verify-title {
  line-height: 110px;
  font-size: 38px;
  font-weight: bold;
  color: #fff;
  text-align: center;
}

.verify-img {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 30px;

  .verifyImg {
    width: 295px;
    height: 92px;
    margin-bottom: 10px;
    background: #4bc4b3;
  }

  .refresh {
    display: flex;
    align-items: center;
    margin-top: 15px;

    span {
      color: #fff;
      font-size: 24px;
      font-weight: 500;
    }

    img {
      width: 20px;
      height: 25px;
      margin-left: 10px;
    }
  }
}

.refresh-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 78px;
  height: 100%;
  background-color: @theme-color;
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
  }
}

.verify-input-box {
  display: flex;
  justify-content: space-between;
  margin: 0 50px;
  margin-top: 24px;

  div {
    flex: 1;

    &:nth-child(n + 2) {
      margin-left: 64px;
    }
  }

  input {
    width: 100%;
    height: 94px;
    line-height: 94px;
    padding: 0;
    padding-left: 20px;
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 30px;
    color: #fff;
    background: #375169;
  }

  input::placeholder {
    font-weight: 500;
    font-size: 26px;
    color: #ffffff;
    opacity: 0.5;
  }

  .error-info {
    font-size: 24px;
    color: #fff;
    position: absolute;
    right: 80px;
    line-height: 88px;
  }
}

.handleBtn {
  display: flex;
  padding: 0 30px;
  gap: 20px;
  margin-top: 52px;
  margin-bottom: 84px;

  .verify-cancel-btn {
    .cancel-btn;
  }

  .verify-confirm-btn {
    .submit-btn;
  }
}

.verify-img-dialog {
  background: url("../assets/img/dialog_bg.png") no-repeat;
  background-size: 100% 100%;
}

.login-btn {
  position: relative;
  font-size: 24px;
  margin-top: 100px;

  button {
    .submit-btn;
    background: url("~@/assets/img/login_btn.png");
    background-size: 100% 100%;
    font-weight: 600;
    font-size: 34px;
  }

  img {
    position: absolute;
    bottom: -90px;
    height: 180px;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
    opacity: 0.8;
  }
}

.showContactMsg {
  text-align: center;
  padding: 15px 10px;

  h3 {
    margin-bottom: 10px;
    margin-top: 25px;
  }

  p {
    line-height: 40px;
    padding: 10px
  }
}
</style>
